

export class UserAddVehicleDetailIdInput implements IUserAddVehicleDetailIdInput {
    /** The auto-generated id of the vehicle */
    vehicleDetailsId!: number;

    constructor(data?: IUserAddVehicleDetailIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleDetailsId = _data["vehicleDetailsId"];
        }
    }

    static fromJS(data: any): UserAddVehicleDetailIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddVehicleDetailIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        return data; 
    }
}

export interface IUserAddVehicleDetailIdInput {
    /** The auto-generated id of the vehicle */
    vehicleDetailsId: number;
}

